import React from 'react';

interface DashedPanelProps {
  children: React.ReactNode;
  className?: string;
  /** Inner padding: compact = 20px uniform; otherwise 24px vertical + fluid horizontal */
  compact?: boolean;
}

/**
 * DashedPanel — dashed purple-border card wrapper used for `Create Quiz|Survey`
 * and `Quiz Management` sections. Tokens: primary/main border, surface/paper
 * background, z4 shadow. Dark mode flips the paper via the semantic CSS var.
 */
export default function DashedPanel({
  children,
  className = '',
  compact = false,
}: DashedPanelProps) {
  const padding = compact
    ? 'p-5'
    : 'px-[clamp(20px,4vw,30px)] py-6';

  return (
    <div
      className={`w-full rounded-3xl border-2 border-dashed border-primary-500 bg-surface-primary shadow-[0_4px_7px_0_rgba(0,0,0,0.1)] ${padding} ${className}`}
    >
      {children}
    </div>
  );
}
